import { Brand, Motto } from "@/components/Brand";

export function AuthLayout({ title, subtitle, children, footer }) {
  return (
    <div className="paper-grain flex min-h-screen flex-col bg-paper">
      <header className="relative mx-auto flex w-full max-w-5xl flex-wrap items-center justify-between gap-3 px-5 py-5 sm:px-8"><Brand /><Motto className="hidden sm:block text-right" testid="auth-motto" /></header>
      <main className="relative mx-auto flex w-full max-w-md flex-1 flex-col justify-center px-5 pb-16">
        <Motto align="center" className="mb-6 sm:hidden" testid="auth-motto-mobile" />
        <div className="soft-card p-7 sm:p-9 fade-up">
          <h1 className="font-jpserif text-3xl">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p>}
          <div className="mt-7">{children}</div>
        </div>
        {footer && <div className="mt-6 text-center text-sm text-muted-foreground">{footer}</div>}
      </main>
    </div>
  );
}

export function Field({ label, id, children }) {
  return (
    <label htmlFor={id} className="block">
      <span className="mb-1.5 block text-xs font-medium uppercase tracking-wide text-muted-foreground">{label}</span>
      {children}
    </label>
  );
}

export const inputCls = "w-full rounded-xl border border-input bg-background px-4 py-3 text-sm outline-none transition-[border-color,box-shadow] focus:border-primary focus:ring-2 focus:ring-primary/20";
export const primaryBtn = "inline-flex w-full items-center justify-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground transition-[transform,opacity] hover:-translate-y-0.5 disabled:opacity-50";
export const ghostBtn = "inline-flex w-full items-center justify-center gap-2 rounded-full border border-border bg-card px-6 py-3 text-sm font-semibold transition-colors hover:bg-accent disabled:opacity-50";

export function ErrorText({ msg, id }) {
  return msg ? <p data-testid={id} className="rounded-lg bg-primary/5 px-3 py-2 text-sm text-primary">{msg}</p> : null;
}
